'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import Text from '@/app/cc/_component/ui/common/Text/Text';
import styles from '@/app/cc/_component/ui/section/AnsimSolution/AnsimSolution.module.scss';
import SolutionCard from '@/app/cc/_component/ui/section/AnsimSolution/SolutionCard';
import { useGetDealType } from '@/app/cc/_stores/useDealTypeStore';
const SOLUTIONS_RENT = [{
  title: '등기 변동 실시간 알림',
  description: '집주인이 몰래 대출을 받거나 가압류가 들어오면 즉시 알려드립니다.',
  icon: {
    src: '/cc/image/icon_siren.svg',
    alt: '등기 변동 실시간 알림',
    backgroundColor: 'red'
  }
}, {
  title: '실손금 보상',
  description: '문제가 생겨도 보증금 손실을 보상 받을 수 있어요.',
  icon: {
    src: '/cc/image/icon_money.svg',
    alt: '실손금 보상',
    backgroundColor: 'yellow'
  }
}, {
  title: '법률 상담 및 선임 비용 지원',
  description: '분쟁이 생기면 전문가가 함께 도와 드립니다.',
  icon: {
    src: '/cc/image/icon_gavel.svg',
    alt: '법률 상담 및 선임 비용 지원',
    backgroundColor: 'navy'
  }
}];
const SOLUTIONS_SALE = [{
  title: '등기 변동 실시간 알림',
  description: '매도인의 이중 계약이나 근저당 설정 시도를 실시간으로 알려드립니다.',
  icon: {
    src: '/cc/image/icon_siren.svg',
    alt: '등기 변동 실시간 알림',
    backgroundColor: 'red'
  }
}, {
  title: '실손금 보상',
  description: '예상치 않은 권리 문제가 발생해도 내 재산 손실을 보상받을 수 있어요.',
  icon: {
    src: '/cc/image/icon_money.svg',
    alt: '실손금 보상',
    backgroundColor: 'yellow'
  }
}, {
  title: '법률 상담',
  description: '분쟁이 발생하면 전문가가 함께 대응해 드려요.',
  icon: {
    src: '/cc/image/icon_gavel.svg',
    alt: '법률 상담',
    backgroundColor: 'navy'
  }
}];
export default function AnsimSolution() {
  const $ = _c(15);
  const dealType = useGetDealType();
  const solutions = dealType === "rent" ? SOLUTIONS_RENT : SOLUTIONS_SALE;
  let t0;
  if ($[0] !== dealType) {
    t0 = <div className={styles.title}>{dealType === "rent" ? <Text as="h3" category="display" variant="eb2" color="var(--color-gray-0)">내 보증금을 지키는<br className="break" /> <span className={styles.highlightText}>3가지</span> 방법</Text> : <Text as="h3" category="display" variant="eb2" color="var(--color-gray-0)">내 집을 지키는<br className="break" /> <span className={styles.highlightText}>3가지</span> 방법</Text>}</div>;
    $[0] = dealType;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Text as="p" category="body" variant="r1" color="var(--color-gray-100)">계약 전체 과정의 위험을 확인하고, 문제가 생겨도 끝까지 대응합니다.</Text>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <div className={styles.textContent}>{t0}{t1}</div>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== solutions) {
    t3 = solutions.map(_temp);
    $[5] = solutions;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <div className={styles.solutionCards}>{t3}</div>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className={styles.content}>{t2}{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className={styles.backgroundImage}><Image src="/cc/image/solution/solution_visual.svg" alt="Ansim Solution" width={480} height={480} /></div>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5) {
    t7 = <section className={styles.ansimSolution}><div className={styles.inner}>{t5}{t6}</div></section>;
    $[13] = t5;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}
function _temp(solution) {
  return <SolutionCard key={solution.title} {...solution} />;
}